import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import { Spacing } from 'works/legacy/lib/style-helper';

export const MakeOfferDrawerFooter = ({
  onSubmit,
  onCancel,
  loading,
  disabled,
}) => {
  return (
    <div className="make-offer-button-footer">
      <Button size="large" onClick={onCancel} disabled={loading}>
        Cancel
      </Button>
      <Button
        type="primary"
        key="MakeOfferDrawerFooterSendOfferButton"
        size="large"
        onClick={onSubmit}
        loading={loading}
        disabled={disabled}
      >
        Send Offer
      </Button>

      <style jsx>{`
        :global(.make-offer-button-footer .ant-btn) {
          margin-right: ${Spacing.baseSpacing / 2}px;
        }
      `}</style>
    </div>
  );
};

MakeOfferDrawerFooter.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
};
